module.exports = __webpack_public_path__ + "static/img/CY@2x.c300d278.jpg";